export default function SettingsService() {
  const vm = this;

  vm.hideOptions = false;
  vm.isWhiteLabel = false;
  vm.showBuilderHeader = false;
  vm.disableBuilderHeaderSave = false;
  vm.subnavHeading = undefined;
  vm.isBeta = false;

  vm.reset = reset;

  function reset() {
    vm.hideOptions = false;
    vm.isWhiteLabel = false;
    vm.showBuilderHeader = false;
    vm.disableBuilderHeaderSave = false;
    vm.subnavHeading = undefined;
    vm.isBeta = false;
  }

  return vm;
}

SettingsService.$inject = [];
